import React, { useEffect, useState } from "react";
import { Handle } from "reactflow";
import "./CustomeNodeData.css";
import {
  fetchAnonProtocols,
  fetchFilters,
  fetchPacsConfiguration,
  fetchPlatformConfigs,
} from "../Modal/Utility";

const CustomNodePacsRecepients = ({ data }) => {

  // console.log("datainrecepient", data);
  return (
    <div className="custom-node">
      <div className="node-header">PACS RECIPIENT </div>
      <div>
        <>
          <div className="name">{data?.pacs?.name}</div>
          <div>AE Title: {data?.pacs?.ae_title}</div>
          <div>IP: {data?.pacs?.ip}</div>
          <div>Port: {data?.pacs?.port}</div>
        </>
      </div>

      <Handle type="target" position="left" />
      <Handle type="source" position="right" />
    </div>
  );
};

export default CustomNodePacsRecepients;
